import { Map } from "immutable";
// NOTE: SHOULD MAKE ALIAS FOR ROOT
import MobileDetect from "../mobileDetect";
import getDeviceDetails, { DeviceGrades } from "./deviceDetection";
import QueryParamUtils from "../queryParamUtils";
import idx from "idx";

import {
  UPDATE_VIEWPORT_DIMENSIONS,
  ORIENTATION_CHANGE_END,
  SET_GYROSCOPE_ENABLED,
} from "./deviceActions";

export const deviceDetails = getDeviceDetails();

const getFullScreenElement = (_) =>
  document.fullscreenElement ||
  document.mozFullScreenElement ||
  document.webkitFullscreenElement ||
  document.msFullscreenElement;

export const isLandscape = () => {
  // If we're supposedly a mobile device yet on a desktop platform (chrome emulator)
  var isDesktopEmulator = isDesktopPlatform() && isMobile();

  var object =
    window.screen.orientation ||
    window.screen.msOrientation ||
    window.screen.mozOrientation ||
    null;
  if (object && !isDesktopEmulator) {
    const typeOfLandscape = idx(object, (_) => _.type.indexOf("landscape"));
    const typeOfPortrait = idx(object, (_) => _.type.indexOf("portrait"));

    if (![-1, null].includes(typeOfLandscape)) {
      return true;
    }
    if (![-1, null].includes(typeOfPortrait)) {
      return false;
    }
  }

  if ("orientation" in window) {
    var value = window.orientation;
    if (value === 0 || value === 180) {
      return false;
    } else if (value === 90 || value === 270) {
      return true;
    }
  }
  // fallback to comparing width to height
  return (
    document.documentElement.clientWidth > document.documentElement.clientHeight
  );
};

export const isFullScreen = (_) => getFullScreenElement() != null;

const isInIframe = (_) => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};

// getters which cover up case where
// scrollbar/window is not taken into consideration
// in certain browsers

//================================================//

var packageJSON = require("../../../package.json");
const APP_VERSION = packageJSON.version;

if (!window.YV_AV) window.YV_AV = {};
window.YV_AV.device = deviceDetails;
window.YV_AV.appVersion = APP_VERSION;

const getViewportWidth = function() {
  return window.innerWidth && document.documentElement.clientWidth
    ? Math.min(window.innerWidth, document.documentElement.clientWidth)
    : window.innerWidth ||
        document.documentElement.clientWidth ||
        document.getElementsByTagName("body")[0].clientWidth;
};

const getViewportHeight = function() {
  return window.innerHeight && document.documentElement.clientHeight
    ? Math.min(window.innerHeight, document.documentElement.clientHeight)
    : window.innerHeight ||
        document.documentElement.clientHeight ||
        document.getElementsByTagName("body")[0].clientHeight;
};

export const isMobile = () => MobileDetect.mobile() !== null;

export const isDesktop = () => !isMobile();

export const isMobileWebSupportedOnDevice = () =>
  isMobile() && deviceDetails.grade == DeviceGrades.A;

const isDesktopPlatform = (_) => navigator.platform.match(/(win|mac|linux)/i);

//================================================//

const INITIAL_STATE = Map({
  appVersion: APP_VERSION,

  grade: deviceDetails.grade,
  gpu: deviceDetails.gpu,
  deviceType: deviceDetails.type,
  deviceName: deviceDetails.deviceName,
  optimalVersion: deviceDetails.version,
  deviceGrade: deviceDetails.grade,
  webVR: deviceDetails.webVR,
  browser: deviceDetails.browser,
  isInIframe: isInIframe(),
  isDeviceOrientationSupported: false,
  isDeviceMobile: MobileDetect.mobile(), // tablet or phone
  isDeviceDesktop: isDesktop(),
  isDesktopPlatform: isDesktopPlatform(),
  isDevicePhone: MobileDetect.phone(),
  isDeviceTablet: MobileDetect.tablet(),
  isDeviceOculus: MobileDetect.oculus(),
  isDeviceIOS: MobileDetect.is("iOS"),
  isDeviceIPhone: MobileDetect.is("iPhone"),
  isDeviceAndroid: MobileDetect.is("AndroidOS"),
  isLandscape: isLandscape(),
  isFullscreen: isFullScreen(),
  isPlatformChrome: MobileDetect.userAgent() == "Chrome",
  isPlatformSafari: MobileDetect.desktopSafari() || MobileDetect.mobileSafari(),
  viewportWidth: document.documentElement.clientWidth,
  viewportHeight: document.documentElement.clientHeight,
  useResponsiveUI: QueryParamUtils.useResponsiveUI(),
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ORIENTATION_CHANGE_END:
    case UPDATE_VIEWPORT_DIMENSIONS:
      const oWidth = state.get("viewportWidth");
      const oHeight = state.get("viewportHeight");
      let vWidth = getViewportWidth();
      let vHeight = getViewportHeight();

      /**
       * Super Hack!!
       * due to an iOS race condition in safari we are going to determine the new orientation.
       */
      if (vWidth == vHeight) {
        //old width has not updated?, but should have, so lets use the old height
        vWidth = vWidth == oWidth ? oHeight : vWidth;
        //old height has not updated?, but should have, so lets use the old width
        vHeight = vHeight == oHeight ? oWidth : vHeight;
      }

      return state.withMutations((mState) => {
        return mState
          .set("viewportWidth", vWidth)
          .set("viewportHeight", vHeight)
          .set("isLandscape", isLandscape())
          .set("isFullscreen", action.isFullScreen);
      });
    default:
      return state;
  }
};
